import { useCallback } from 'react';
import { ToastType, useToastStore } from '../store/toastStore';

type ShowToastParams = {
  title?: string;
  description?: string;
  duration?: number;
};

const DEFAULT_DURATION = 4000;

export function useToast() {
  const addToast = useToastStore((state) => state.addToast);
  const removeToast = useToastStore((state) => state.removeToast);

  const showToast = useCallback(
    (type: ToastType, params: ShowToastParams) => {
      const duration = params.duration ?? DEFAULT_DURATION;
      return addToast({
        type,
        duration,
        title: params.title,
        description: params.description,
      });
    },
    [addToast]
  );

  return {
    success: (title: string, description?: string, options?: Omit<ShowToastParams, 'title' | 'description'>) =>
      showToast('success', { title, description, ...options }),
    error: (title: string, description?: string, options?: Omit<ShowToastParams, 'title' | 'description'>) =>
      showToast('error', { title, description, ...options }),
    info: (title: string, description?: string, options?: Omit<ShowToastParams, 'title' | 'description'>) =>
      showToast('info', { title, description, ...options }),
    removeToast,
  };
}
